@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/spacers';

.container {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  padding-top: 2.2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media (max-width: map.get($grid-breakpoints, md)) {
    padding-top: 5rem;
    text-align: center;
  }

  &__inner {
    margin: 0 10%;

    @media (max-width: map.get($grid-breakpoints, lg)) {
      margin: 0 5%;
    }

    &--align-left {
      align-self: flex-start;
    }
  }
}

.temavalg-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 4rem 5rem;
  width: 100%;
  max-width: 90rem;
  padding-top: 2.125rem;

  @media (max-width: map.get($grid-breakpoints, lg)) {
    padding-top: 2.9rem;
  }

  @media (max-width: map.get($grid-breakpoints, md)) {
    padding-top: 2rem;
    margin-bottom: 3rem;
    row-gap: 0.68rem;
  }

  &--small {
    max-width: 65rem;
  }
}

.button--spacing {
  &:first-of-type {
    margin: 4rem 0 2rem;

    @media (max-width: map.get($grid-breakpoints, md)) {
      margin: 2rem 0;
    }
  }

  @media (max-width: map.get($grid-breakpoints, md)) {
    display: inline-flex;
    margin: 2rem 0;
  }
}
